import React from 'react';
import { Link } from 'react-router-dom';
import { CHAPTERS } from '../data/chapters';
import { useMediaQuery } from '../hooks/useMediaQuery';
import { useHowItWorksDesktopModal } from '../context/HowItWorksModalContext';
import { FERTILITY_DEMO_HOME } from '../constants/paths';

/** Matches `LandingNav`: chapter marketing pages, then Demo, Pricing, Blog, About, Contact */
const linkStyle = (linkColor) => ({ color: linkColor, fontWeight: 600, fontSize: 12 });
const linkButtonReset = (linkColor) => ({
  color: linkColor,
  fontWeight: 600,
  fontSize: 12,
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  font: 'inherit',
  textAlign: 'inherit',
  textDecoration: 'none',
});

export function FooterNavLinks({ linkColor = 'var(--muted)' }) {
  const narrow = useMediaQuery('(max-width: 900px)');
  const { openDesktopOnlyModal } = useHowItWorksDesktopModal();
  return (
    <nav
      aria-label="Footer navigation"
      style={{ display: 'flex', gap: 14, flexWrap: 'wrap', justifyContent: 'flex-start', fontSize: 12, lineHeight: 1.35 }}
    >
      {CHAPTERS.map((c) => (
        <Link key={c.id} to={`/chapter/${c.id}`} style={linkStyle(linkColor)}>
          {c.name}
        </Link>
      ))}

      {narrow ? (
        <button
          type="button"
          onClick={openDesktopOnlyModal}
          style={linkButtonReset(linkColor)}
        >
          Demo
        </button>
      ) : (
        <Link to={FERTILITY_DEMO_HOME} style={linkStyle(linkColor)}>
          Demo
        </Link>
      )}

      <Link to="/pricing" style={linkStyle(linkColor)}>
        Pricing
      </Link>

      <Link to="/blog" style={linkStyle(linkColor)}>
        Blog
      </Link>

      <Link to="/about" style={linkStyle(linkColor)}>
        About us
      </Link>

      <Link to="/contact" style={linkStyle(linkColor)}>
        Contact
      </Link>
    </nav>
  );
}

